export * from './app-footer.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-footer/index.ts